import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute, Router } from '@angular/router';
import { ABMRolesService, CuentasService, NavigationService } from '../../../services';
import { Location } from '@angular/common';
import { PATH_ABM } from '../../../navigation/navigation.module';
import { PermisosService } from '../../../services/permisos-service';

@Component({
  selector: 'app-categoria-detail',
  templateUrl: './categoria-detail.component.html',
  styleUrls: ['./categoria-detail.component.scss']
})
export class CategoriaDetailComponent implements OnInit {

  private categoriaId;
  public categoria: any = {};

  public acopios = [];

  acopiosShowSelected = true;
  acopiosShowUnselected = true;

  loadedSecondTab = false;

  @ViewChild('categoriaNameInput') categoriaNameInput;

  constructor(private route: ActivatedRoute,
              private location: Location,
              private abmService: ABMRolesService,
              private router: Router,
              private navService: NavigationService,
              private permisosService: PermisosService) {
    this.permisosService.verificarAccesoDeURL();
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.categoriaId = this.route.snapshot.params['id'];

      this.loadData();
    });
  }

  loadData(){

    if (this.categoriaId){
      this.abmService.getCategorias()
        .subscribe(data => {
          this.categoria = data.find(d => d.Id === Number(this.categoriaId));

          this.getAcopios();
        });
    } else {
      this.categoria = this.abmService.getTmpCategoria();
      if (!this.categoria) {
        this.categoria = {
          "CategoriaNombre": '',
          "Acopios": [],
        };
      }
      this.getAcopios();
    }
  }

  getAcopios(){
    this.abmService.getAcopios()
      .subscribe(data => {
        this.acopios = data.map(a => {
          a.checked = this.categoria.Acopios.findIndex(e => e.Id === a.Id)>=0;
          return a;
        });

      });
  }

  onNavigateBack(){
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/'+PATH_ABM+'/categorias');
    }
  }

  onAcopioChecked(acopio, e) {
    acopio.checked = e.checked;
  }

  onSelectAll() {
    this.acopios.forEach(a => a.checked = true);
  }

  onDeselectAll() {
    this.acopios.forEach(a => a.checked = false);
  }

  onSubmit(){
    this.categoria.Acopios = this.acopios.filter(e => e.checked).map(e => { return {Id: e.Id} });

    if (this.categoria.Id) {
      this.abmService.updateCategoria(this.categoria).subscribe(
        data => {
          this.router.navigate([PATH_ABM + '/categorias']);
      });
    } else {
      this.abmService.createCategoria(this.categoria).subscribe(
        data => {
          this.abmService.setTmpCategoria(null);
          this.router.navigate([PATH_ABM + '/categorias']);
      });
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/categoria-detail/categoria-detail.component.ts